// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__8Mneo","page":"pagination_page__b4-Jf","page_active":"pagination_page_active__gZQsR"};